export const FETCH_POSTS = 'FETCH_POSTS';
export const NEW_POST = 'NEW_POST';


// WEBPACK FOOTER //
// ./src/reducers/posts/actionConst.js